module.exports = __webpack_public_path__ + "a768e7de/img/grid-web-icon.d0395d64.svg";